import ConsultaBase from "../shared/ConsultaBase";
import { licuador1CompConsultaConfig } from "../config/licuador1CompConsulta";

const CLicuador1Comp = () => {
  return <ConsultaBase config={licuador1CompConsultaConfig} />;
};

export default CLicuador1Comp;  